import React from 'react';

interface CloseButtonIconProps {
    color: string;
}

const CloseButtonIcon = (props: CloseButtonIconProps): React.JSX.Element => {
    const { color } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
        >
            <path
                d="M5.00494 5.96195L1.63594 9.33095L0.751938 8.44695L4.12094 5.07795L0.585938 1.54295L1.45894 0.669446L4.99444 4.20445L8.52994 0.668945L9.41394 1.55295L5.87844 5.08845L9.23744 8.44745L8.36394 9.32095L5.00494 5.96195Z"
                fill={color}
                data-testid="close-button-icon-color"
            />
        </svg>
    );
};

export default CloseButtonIcon;
